// 浅色
const lightTheme = {
  '--bg_white_1': '#FFFFFF',
  '--bg_grey_1': '#F6F7F9',
  '--bg_grey_2': '#F3F8FC',
  '--bg_stroke_grey_3_1': '#EEEEEE',
  '--bg_stroke_grey_3_2': '#EFEFEF',
  '--bg_stroke_grey_3_16': 'rgba(26, 32, 41, 0.16)',
  '--bg_stroke_grey_3_4': '#E7E7E7',
  '--bg_stroke_grey_3_5': '#F8F8F8',
  '--bg_bt_black_1': '#1A2029',
  '--bg_floating_white_1': '#FFFFFF',
  '--bg_pop_white_1': '#FFFFFF',
  '--bg_idea_blue_1': '#EDF8FC',
  '--hover_icon_grey_1': 'rgba(79, 88, 102, 0.06)',
  '--hover_icon_grey_2': 'rgba(79, 88, 102, 0.08)',
  '--tips_toast_black_1': '#1A2029',
  '--bg_blue_1': '#2454FF',
  '--bg_blue_2': 'rgba(36, 84, 255, 0.06)',
  '--bg_chat_white_2': 'rgba(255, 255, 255, 0.6)',
  '--bg_lable_grey_2': 'rgba(79, 88, 102, 0.16)',
  '--tips_toast_stroke_grey_1': '#EEEEEE',
  '--floating_stroke_grey_1': '#F5F5F5',
  '--box_stroke_grey_1': '#D3D7DD',
  '--box_stroke_black_2': '#1A2029',
  '--bt_stroke_black_1': '#1A2029',
  '--txt_stroke_blue_1': '#2454FF',
  '--txt_icon_black_1': '#1A2029',
  '--txt_icon_black_2': '#4F5866',
  '--txt_icon_grey_3': 'rgba(79, 88, 102, 0.6)',
  '--txt_icon_grey_4': 'rgba(26, 32, 41, 0.40)',
  '--txt_icon_grey_5': '#838A95',
  '--txt_icon_grey_6': '#B0B7C0',
  '--txt_icon_white_7': '#FFFFFF',
  '--txt_icon_grey_6_x': '#C5CAD1',
  '--bg_stroke_grey_3_2(x)': '#EFEFEF',
  '--mask_white_1': 'rgba(255, 255, 255, 0.12)',
  '--hover_bt_blue_1': '#0033E7',
  '--glm4_lable_black_1': '#1A2740',
  '--search_blue_1': '#464E94',
  '--search_txt_blue_1': '#464E94',
  '--warn_lable_red_1': '#464E94',
  '--warn_red_1': '#F94242',
  '--hover_warn_red_1': '#D01616',
  '--warn_lable_red_2': '#A9433C',
  '--warn_lable_yellow_1': '#FF8412',
  '--warn_lable_yellow_2': '#FFC83C',
  '--right_lable_green_1': '#37D647',
  '--right_txt_green_1': '#13A819',
  '--angent_special_grey_1': '#F6F7F9',
  '--angent_special_grey_2': '#EEEEEE',
  '--bg_chat_box_grey_1': '#FFFFFF',
  '--stroke_chat_box_grey_1': '#EEEEEE',
  '--bg_angent_chat_grey_1': '#FFFFFF',
  '--agent_guide_shadow': 'rgba(179, 188, 205, 0.2)',
  '--stroke_chat_box_grey_2': 'rgba(26, 32, 41, 0.08)',
  '--el-radio-input-border': '1px solid #d3d7dd',
  '--bg_goods': '#F2F5FF',
  '--bg_goods_new': '#ebeef8',
  '--box_shadow_1': 'rgba(26, 72, 137, 0.08)',
  '--el-skeleton-bgcolor': '#f2f0f5',
  '--float_List': '#ffffff',
  '--agent_bg_panel': 'rgba(22, 47, 82, 0.04)',
  '--selection_bg_blue': '#c8deff',
  '--box_new_boxshadow': 'rgba(19, 19, 20, 0.2)',
  '--chat_box_shadow_1': 'rgba(36, 84, 255, 0.04)',
  '--angent_special_grey_3': '#D4DDFF',
  '--vip_box_stroke_1': 'rgba(22, 76, 255, 0.16)',
  '--vip_box_bg_1': 'rgba(36, 84, 255, 0.04)',
  '--linear_bg_rate':
    'linear-gradient(90deg, rgba(36, 95, 255, 0.1) 0%, rgba(36, 95, 255, 0.1) 100%)',
  '--linear_bg_rate_2':
    'linear-gradient(90deg, rgba(36, 95, 255, 0.1) 0%, rgba(243, 14, 13, 0.12) 100%)',
  '--bg_chat_white_3': 'rgb(255, 255, 255)',
  '--bg_shadow': 'rgba(17, 49, 95, 0.08)',
  '--chat_box_shadow_2': 'rgba(36, 84, 255, 0.04)',
  '--bg_chat_white_4': 'rgba(255, 255, 255, 0.60)',
  '--txt-icon-grey-360': 'rgba(79, 88, 102, 0.60)',
  '--card_swiper_gradient_1': 'rgba(255, 255, 255, 0)',
  '--card_swiper_gradient_2': '#FFF',
  '--image_swiper_gradient_1': 'rgba(246, 247, 249, 0)',
  '--image_swiper_gradient_2': '#f6f7f9',
  '--hover-icon-grey-28': 'rgba(79, 88, 102, 0.08)',
  '--txt-icon-grey-430': 'rgba(26, 32, 41, 0.40)'
}
export default lightTheme
